import React from 'react';
import BaseMultiCheckbox from "Fratello/Atoms/MultiCheckbox";

export default class MultiCheckbox extends BaseMultiCheckbox {
    constructor(props) {
        super(props);

        this.state = {open: false}
    }
    render() {
         // TO DO: Improvement: There are no unique name/id for the input elements
         // Now, I will use the "value". But if there are 2 equal values, the checkbox/radio element will not work correctly

         const options = this.state.open ? Object.keys(this.props.choices) : Object.keys(this.props.choices).slice(0, 3);

         return (
             <div>
                 <div className='read-more-wrap'>
                     {options.map(value => {
                         let checked = this.props.value === value;
                         if (this.props.multiple && typeof this.props.value !== 'undefined' && null !== this.props.value) {
                             checked = this.props.value.indexOf(value) >= 0;
                         }
                         return (
                             <div key={value} className={this.props.multiple ? 'checkbox' : 'radio'}>
                                 <input
                                     type={this.props.multiple?'checkbox':'radio'}
                                     name={this.props.name}
                                     id={`${this.props.name}-${value}`}
                                     defaultChecked={checked}
                                     value={value}
                                     disabled={this.props.disabled || (
                                         typeof this.props.availableChoices !== 'undefined'
                                         && null !== this.props.availableChoices
                                         && typeof this.props.availableChoices[value] === 'undefined'
                                     )  ?  true : false}
                                     readOnly={this.props.readonly}
                                     onChange={this.onChange.bind(this)}
                                 />
                                 <label htmlFor={`${this.props.name}-${value}`} className={checked?' checked':''}>{this.props.choices[value]}</label>
                             </div>
                         )
                 })}</div>
                {Object.keys(this.props.choices).length > 3 ? <label htmlFor='' className='btn btn-link' onClick={(event) => {
                    event.preventDefault();
                    this.setState({open: !this.state.open});
                }}>
                    <i className={`icon icon-readmore ${this.state.open ? "up" : "down"}`}></i>
                    <span>{this.state.open ? this.props.labels.less : this.props.labels.more}</span>
                </label> : '' }
             </div>
         );
    }
}



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Atoms/MultiCheckbox.jsx